import React from 'react';
import { Link } from './uiold';

export default function ExampleLink(props: {
  resourceID: string;
  accountID: string;
  seasonID: string | undefined;
}) {
  const { resourceID, accountID, seasonID } = props;
  const fullID = seasonID ? accountID + '-' + seasonID : accountID;
  const url = `/site-example/${fullID}/${resourceID}`;
  return (
    <Link href={url} target="_blank" style={{ marginVertical: 4 }}>
      {t('See an example in a website')}
    </Link>
  );
}
